/* @flow */
import { action, observable } from 'mobx';
import { ApiModel } from 'api/ApiModel';

export default class NavigationStore extends ApiModel {
  @observable accountPath: Array<*> = new Array(Object);

  @observable currentItem = {};

  @action
  pushPath = (level: *, path: string, tab: * = 0) => {
    this.accountPath[level] = { path, tab };
  };

  reset = () => {
    this.accountPath = [{}];
  };
}

export type TypeNavigationStore = {|
  accountPath: Array<*>,
|};
